import { render } from "./legoIconButton.vue?vue&type=template&id=5bee91d0"
import script from "./legoIconButton.vue?vue&type=script&lang=js"
export * from "./legoIconButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoIconButton/legoIconButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bee91d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bee91d0', __exports__)) {
    api.reload('5bee91d0', __exports__)
  }
  
  module.hot.accept("./legoIconButton.vue?vue&type=template&id=5bee91d0", () => {
    api.rerender('5bee91d0', render)
  })

}


export default __exports__